// import { useEffect } from 'react';
// import { v4 as uuidv4 } from 'uuid';

// const browserSessionID = () => {
//   useEffect(() => {
//     let sessionId = sessionStorage.getItem('sessionID');
//     console.log('Existing sessionID:', sessionId);
//     if (!sessionId) {
//       sessionId = uuidv4();
//       sessionStorage.setItem('sessionID', sessionId);
//       console.log('New sessionID set:', sessionId);
//     } else {
//       console.log('SessionID already set:', sessionId);
//     }
//   }, []);
// };

// export default browserSessionID;


import { v4 as uuidv4 } from 'uuid';

export const getSessionId = () => {
  let sessionId = sessionStorage.getItem('sessionID');
  if (!sessionId) {
    sessionId = uuidv4();
    sessionStorage.setItem('sessionID', sessionId);
  }
  return sessionId;
};

export const loadState = (key, defaultValue) => {
  const sessionId = getSessionId(); // Ensures sessionID is set and returns it
  console.log('SessionID:', sessionId); // Optional: Output the session ID

  try {
    const serializedState = sessionStorage.getItem(key);
    if (serializedState === null) {
      return defaultValue;
    }
    return JSON.parse(serializedState);
  } catch (error) {
    return defaultValue;
  }
};

export const saveState = (key, obj) => {
  try {
    sessionStorage.setItem(key, JSON.stringify(obj));
  } catch (error) {}
};
